<template>
  <v-card class="pa-0 h-100 app-box-shadow">
    <v-card-title
      class="px-4 py-1 ma-0 text_color--text d-flex justify-space-between"
      :class="getBgColor(trip)"
    >
      <h6>{{ title }}</h6>

      <!-- <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="trip && trip.is_more_trips_available"
            icon
            class="white--text"
            @click="getTripList(trip.status)"
          >
            <v-icon v-bind="attrs" v-on="on"> mdi-eye </v-icon></v-btn
          >
        </template>
        <span class="text-capitalize">{{
          trip && (trip.status == "Completed" || trip.status == "Cancelled")
            ? "View Previous Trips"
            : trip && trip.status == "Scheduled"
            ? "View Upcoming Trips"
            : "-"
        }}</span>
      </v-tooltip> -->
    </v-card-title>
    <v-card-text class="ma-0 pt-2">
      <v-row v-if="trip == null">
        <v-col cols="12" class="d-flex justify-center">
          <h5 class="font-weight-bold text_color--text">No trip at the moment</h5>
        </v-col>
      </v-row>

      <v-row
        v-if="trip != null"
        no-gutters
        style="border-bottom: 1px solid #e6e7e8; min-height: 6vh"
      >
        <v-col cols="12" class="d-flex justify-space-between">
          <h4 class="text_color--text">
            {{ trip.reference_number }}
          </h4>
          <h4 class="text_color--text">
            {{ trip.status }}
          </h4>
        </v-col>
        <v-col
          cols="6"
          class="pt-1"
          :class="
            trip && trip.status == 'Scheduled'
              ? 'd-none'
              : 'd-flex justify-start'
          "
        >
          <h5 class="text_color--text font-weight-medium text-caption">
            Orders Attempted: &nbsp;
            {{ trip.delivered_order }}
            /
            {{ trip.total_order }}
          </h5>
        </v-col>
        <v-col
          cols="6"
          class="text-right py-1"
          :class="
            trip && trip.status == 'Scheduled' ? 'd-none' : 'd-flex justify-end'
          "
          v-if="trip && trip.is_trip_delayed"
        >
          <h5 class="text_color--text font-weight-medium text-caption">
            Delay:
            <b class="ml-2">{{ trip.delay }} min</b>
          </h5>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class=""
        v-for="(value, key, index) of trip && trip.trip_extra_info"
        :key="index"
      >
        <v-col cols="12" class="d-flex justify-space-between py-1" style="10vh">
          <h5
            class="font-weight-medium text-caption"
            style="text-transform: capitalize"
          >
            {{ key.replace(/_/g, " ") }}
          </h5>
          <h5 class="font-weight-black text-caption">
            {{ value }}
          </h5>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-0 ma-0">
      <DialogBase
        :title="previewTripTitle(trip)"
        v-model="previewTrip"
        width="900"
        ref="tripsList"
      >
        <template #information>
          <v-row no-gutters>
            <v-col cols="12" class="pt-4">
              <AgGridVue
                @grid-ready="gridReady"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :context="context"
                :row-data="previewTripsList"
                style="width: 100%; height: 450px"
                class="ag-theme-material app-table"
              >
              </AgGridVue>
            </v-col>
            <v-col cols="12" class="pt-3 d-flex justify-end">
              <CommonPagination
                :page-no="pageNo"
                :num-of-pages="totalPages"
                :page-size="itemsPerPage"
                @nextPage="nextPage"
                @prevPage="prevPage"
                @itemsPerPageChange="itemsPerPageChange"
              />
            </v-col>
          </v-row>
        </template>
      </DialogBase>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import { bus } from "@/main";

export default {
  components: { AgGridVue, DialogBase },
  props: {
    title: {
      type: String,
    },
    trip: {
      type: Object,
      default: () => ({}),
    },
    moduleType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      itemsPerPage: 10,
      previewTrip: false,

      totalItems: 0,
      pageNo: 1,
      totalCount: 0,

      // grid variables
      gridApi: null,
      columnApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
      columnDefs: [
        {
          headerName: "Reference Number",
          field: "reference_number",
        },
        {
          headerName: "Total Orders",
          field: "total_order",
        },
        {
          headerName: "Status",
          field: "status",
        },
      ],
      previewTripsList: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    closeDialog() {
      this.previewTrip = false;
      this.previewTripsList = [];
    },

    nextPage() {
      this.pageNo++;
      this.getTripList();
    },

    prevPage() {
      this.pageNo--;
      this.getTripList();
    },

    itemsPerPageChange(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getTripList();
    },

    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },

    getBgColor(trip) {
      if (trip) {
        if (
          (trip && trip.status && trip.status == "Completed") ||
          trip.status == "Cancelled"
        ) {
          return "success";
        } else if (
          (trip && trip.status && trip.status == "Active") ||
          trip.status == "Pause" ||
          trip.status == "Loading" ||
          trip.status == "Loading Completed"
        ) {
          return "accent";
        } else if (trip && trip.status && trip.status == "Scheduled") {
          return "subHeading";
        }
      } else {
        return "subHeading";
      }
    },

    getTripList() {
      this.previewTrip = true;
      if (this.moduleType == "driver") {
        if (
          this.trip &&
          this.trip.status &&
          (this.trip.status == "Cancelled" || this.trip.status == "Completed")
        ) {
          this.getDriverPreviousTrips();
        } else {
          this.getDriverUpcomingTrips();
        }
      } else {
        if (
          this.trip &&
          this.trip.status &&
          (this.trip.status == "Cancelled" || this.trip.status == "Completed")
        ) {
          this.getVehiclePreviousTrips();
        } else {
          this.getVehicleUpcomingTrips();
        }
      }
    },

    previewTripTitle(trip) {
      if (trip && (trip.status == "Completed" || trip.status == "Cancelled")) {
        return "Previous Trips";
      } else if (trip && trip.status == "Scheduled") {
        return "Upcoming Trips";
      } else {
        return "";
      }
    },

    getDriverPreviousTrips(params = {}) {
      params = {
        ...params,
        limit: this.itemsPerPage,
        offset: this.offset,
        id: this.$route?.params?.id,
      };

      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverPreviousTrips(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.previewTripsList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },

    getDriverUpcomingTrips(params = {}) {
      params = {
        ...params,
        limit: this.itemsPerPage,
        offset: this.offset,
        id: this.$route?.params?.id,
      };
      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverUpcomingTrips(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.previewTripsList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },

    getVehiclePreviousTrips(params = {}) {
      params = {
        ...params,
        limit: this.itemsPerPage,
        offset: this.offset,
        id: this.$route?.params?.id,
      };
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .getVehiclePreviousTrips(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.previewTripsList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getVehicleUpcomingTrips(params = {}) {
      console.log(this.$route.params.id);
      params = {
        ...params,
        limit: this.itemsPerPage,
        offset: this.offset,
        id: this.$route?.params?.id,
      };
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .getVehicleUpcomingTrips(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.previewTripsList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
